import React from 'react';
import { STRATEGY_CODE_VIEWS, StrategyCodeType } from './index';
import type {
  CriteriaInputs,
  StrategyDetails,
} from 'src/components/Strategy/shared/types';

interface StrategyCodesListProps {
  criteriaInputs: CriteriaInputs;
  strategyDetails?: StrategyDetails;
}

/**
 * Orchestrator component that delegates to strategy-specific views
 * based on the strategy type using the STRATEGY_CODE_VIEWS registry
 */
const StrategyCodesList: React.FC<StrategyCodesListProps> = ({
  criteriaInputs,
  strategyDetails,
}) => {
  if (!strategyDetails) {
    return null;
  }

  const strategyType = strategyDetails.type as StrategyCodeType;
  const ViewComponent = STRATEGY_CODE_VIEWS[strategyType];

  if (!ViewComponent) {
    return null;
  }

  return (
    <ViewComponent
      criteriaInputs={criteriaInputs}
      strategyDetails={strategyDetails}
    />
  );
};

export default StrategyCodesList;
